module.exports = __webpack_public_path__ + "static/media/free-storage.6ada30d6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/venueStatus/free-storage.svg
// module id = 631
// module chunks = 1